import { createPaginatedResponseSchema } from '@/schemas/pagination.schema'
import { TransactionListItemSchema } from '@/schemas/transactions.schema'
import { useQuery } from '@tanstack/react-query'
import { getApplicantTransactions, TransactionQuery } from '../requests'

export const useGetTransactions = (query: TransactionQuery) => {
  return useQuery({
    queryKey: ['applicantTransactions', query],
    refetchOnMount: "always",
    queryFn: async () => {
      const response = await getApplicantTransactions(query)
      return createPaginatedResponseSchema(TransactionListItemSchema).parse(
        response.data
      )
    },
  })
}